<template>
  <div class="app-picker">
    <v-text-field
      :value="readableTime"
      prepend-inner-icon="mdi-calendar"
      readonly
      v-bind="$attrs"
      @click="modal = true"
    />
    <v-dialog
      ref="dialog"
      v-model="modal"
      width="390px"
      :return-value.sync="date"
    >
      <v-card
        color="transparent"
        dark
      >
        <v-tabs
          v-model="tab"
          grow
        >
          <v-tab>
            <v-icon> mdi-calendar </v-icon>
          </v-tab>
          <v-tab>
            <v-icon> mdi-alarm </v-icon>
          </v-tab>
        </v-tabs>
        <v-tabs-items
          v-model="tab"
        >
          <v-tab-item>
            <v-date-picker
              v-model="date"
              first-day-of-week="1"
              dark
              no-title
              scrollable
              full-width
              v-bind="props"
              @click:date="tab = 1"
            />
          </v-tab-item>
          <v-tab-item>
            <v-time-picker
              v-model="time"
              dark
              format="24hr"
              scrollable
              full-width
              type="month"
              :allowed-hours="allowedHourses"
              :allowed-minutes="allowedMinutes"
            >
              <v-spacer />
            </v-time-picker>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-btn
            class="w-50"
            color="success"
            @click="$refs.dialog.save(date)"
          >
            OK
          </v-btn>
          <v-btn
            class="w-50 ml-1"
            @click="modal = false"
          >
            Отменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import format   from 'date-fns/format';
import isSameDay  from 'date-fns/isSameDay';
import getHours  from 'date-fns/getHours';
import getMinutes from 'date-fns/getMinutes';
import { isSameHour } from '@/helpers/date';
import addMinutes from 'date-fns/addMinutes';

export default {
  props: {
    value: { type: [Number, Date, String], required: false, default: () => new Date() },
    min: { type: [Number, Date, String], required: false, default: () => '' },
    max: { type: [Number, Date, String], required: false, default: () => '' },
  },
  data: () => ({
    tab: null,
    date: null,
    modal: false,
    time: '00:00',
  }),
  computed: {
    props() {
      const props = {};
      if (this.min) {
        props.min = new Date(this.min).toISOString().substr(0, 10);
      }
      if (this.max) {
        props.max = new Date(this.max).toISOString().substr(0, 10);
      }

      return props;
    },
    formattedDate() {
      const date = new Date(this.date);
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      const timeParts = this.time ? this.time.split(':') : '00:00';
      const [hour, minutes] = timeParts;
      const result = new Date(year, month, day, hour, minutes, 0);
      // eslint-disable-next-line no-restricted-globals
      return !isNaN(result.getTime()) ? result : new Date();
    },

    readableTime() {
      const date = new Date(this.value);
      if (!this.date) return 'Не указано';
      return format(date, 'dd.MM.yyyy HH:mm');
    },

    allowedHourses() {
      let minHours = 0;
      let maxHours = 23;

      if (this.min) {
        const min = new Date(this.min);
        if (isSameDay(min, new Date(this.value))) {
          minHours = getHours(min);
        }
      }
      if (this.max) {
        const max = new Date(this.max);
        if (isSameDay(max, new Date(this.value))) {
          maxHours = getHours(max);
        }
      }

      return (v) => v >= minHours && v <= maxHours;
    },
    allowedMinutes() {
      let minMinutes = 0;
      let maxMinutes = 60;

      const currentDate = new Date(this.value);

      if (this.min) {
        const min = addMinutes(new Date(this.min), 1);
        if (isSameDay(min, currentDate)  && isSameHour(min, currentDate)) {
          minMinutes = getMinutes(min);
        }
      }
      if (this.max) {
        const max = new Date(this.max);
        if (isSameDay(max, currentDate && isSameHour(max, currentDate))) {
          maxMinutes = getMinutes(max);
        }
      }

      return (v) => v >= minMinutes && v < maxMinutes;
    },
  },
  watch: {
    value(val) {
      if (!val) return;
      this.date = new Date(this.date).toISOString().substr(0, 10);

      const date = new Date(val);

      if (date) {
        const time = `${date.getHours()}:${date.getMinutes()}`;
        this.time = time;
      }
    },
    date(val) {
      this.date = val;
      this.$emit('input', this.formattedDate);
    },

    time() {
      this.$emit('input', this.formattedDate);
    },

    modal(val) {
      if (!val) {
        this.tab = 0;
      }
    },
  },
  created() {
    this.date = this.value || new Date();
    if (!this.value) return;
    const date = new Date(this.value);
    if (date) {
      const time = `${date.getHours()}:${date.getMinutes()}`;
      this.time = time;
    }
  },
};
</script>
<style lang="scss">

.v-picker {
  .v-picker__title.primary,
  .v-picker__body {
    background: transparent !important;
    background-color: transparent !important;
  }

}
.picker-title {
  .v-picker__title.primary {
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
  }

  .v-time-picker-title {
    /* color: black !important; */
    & > * {
      font-size: 1.5rem !important;
    }
  }
}

.w-50 {
  width: 50%;
}
</style>
<style lang="scss" scoped>
.theme--dark.v-card{
  background-color: transparent;
}

</style>
